import { constants } from "../../../constants";

export default class ClosePaytable {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.closePaytable();
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.walletProtocol) {
            case constants.POKERSTARS:
                event["xc2rgCloseHelp"] = this._default;
                break;
            default:
                event["closePaytable"] = this._default
        }

        return event;
    }
}
